import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LoginService } from '@pxl/models/contracts';

export function isKnownUserGuard(targetState: boolean, redirectTo: any[], appendParams: string[] = []): CanActivateFn {
    return async (route, state) => {
        const router = inject(Router);
        const loggedInState = await inject(LoginService).isLoggedIn();
        if (loggedInState === targetState) return true;
        const paramsToAppend = appendParams.map((key) => route.params[key] ?? route.queryParams[key] ?? '');
        return router.createUrlTree(
            [...redirectTo, ...paramsToAppend],
            targetState
                ? {
                      queryParamsHandling: '',
                      queryParams: {
                          destinationUrl: state.url,
                      },
                  }
                : { queryParamsHandling: 'preserve' },
        );
    };
}
